// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_MortgagePartOverpaymentType.proto

export enum ENUM_MortgagePartOverpaymentType {
  MORTGAGE_PART_OVERPAYMENT_TYPE_UNSPECIFIED = 'MORTGAGE_PART_OVERPAYMENT_TYPE_UNSPECIFIED',
  MORTGAGE_PART_OVERPAYMENT_TYPE_ONE_TIME = 'MORTGAGE_PART_OVERPAYMENT_TYPE_ONE_TIME',
  MORTGAGE_PART_OVERPAYMENT_TYPE_RECURRING = 'MORTGAGE_PART_OVERPAYMENT_TYPE_RECURRING',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
